import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { ChevronRight, Visibility } from 'assets/assetsV1/iconComponents';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';
import { routes } from 'constants/routes';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

import { useSaveFormFillings } from '../../Hooks/dataHooks/formFillingsDataHooks';
import { useSaveShareResults } from '../../Hooks/dataHooks/shareResultsDataHooks';

const getFormPageRoute = () =>
  checkNewNavEnabled() ? staticRoutesWithCustomSidebar.reviewsFormFilling : routes.performanceReview.forms;

const getResultPageRoute = () =>
  checkNewNavEnabled() ? staticRoutesWithCustomSidebar.reviewsResultPage : routes.performanceReview.result;

export const PreviewFormButton = ({
  feedbackFormId,
  providerType,
  isDisabled,
  label = '',
  isShareResultPage = false,
}) => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const saveFormFillingDataMutation = useSaveFormFillings({ isPreviewClick: true });
  const saveShareResultsDataMutation = useSaveShareResults({ isPreviewClick: true });

  const handleClick = (e) => {
    e.stopPropagation();
    if (isShareResultPage) {
      saveShareResultsDataMutation.mutate();
    } else {
      saveFormFillingDataMutation.mutate();
    }
  };

  let buttonLabel = 'Preview form filling';
  if (label) {
    buttonLabel = label;
  } else if (providerType === REVIEW_PROVIDER_TYPES.PEER) {
    buttonLabel = 'Preview peer form filling';
  } else if (providerType === REVIEW_PROVIDER_TYPES.UPWARD) {
    buttonLabel = 'Preview upward form filling';
  } else if (providerType === REVIEW_PROVIDER_TYPES.MANAGER) {
    buttonLabel = 'Preview manager form filling';
  } else if (providerType === REVIEW_PROVIDER_TYPES.DLM) {
    buttonLabel = 'Preview dotted line manager form filling';
  }

  const route = (isShareResultPage ? getResultPageRoute() : getFormPageRoute())
    .replace(':reviewId', feedbackFormId)
    .replace(':employeeId', loggedInEmployeeId);
  const routeWithQuery = !isDisabled ? `${route}?isPreview=true&providerType=${providerType}` : '';

  return (
    <Tooltip
      isDisabled={!isDisabled}
      label="This view is currently disabled as there are no questions within the template. Please go back to the 'Elements' step to review the template."
      shouldWrapChildren
    >
      <Button
        variant="tertiary"
        ml={5}
        as="a"
        target="_blank"
        style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}
        href={routeWithQuery}
        isDisabled={isDisabled}
        onClick={handleClick}
        StartIcon={Visibility}
        EndIcon={ChevronRight}
      >
        {buttonLabel}
      </Button>
    </Tooltip>
  );
};
